import Immutable from 'immutable';

export default (state, action, cb) => {
  return state.withMutations((map) => {
    if (cb) {
      cb(map, action);
    } else {
      map.set('data', Immutable.fromJS(action.payload));
    }
  });
};



// WEBPACK FOOTER //
// ./app/lib/mapReducer.js